import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { range } from '@belong/common';
import { IconLeftCaret, IconRightCaret } from '@belong/icons';
import clsx from 'clsx';
import { LinkBase } from '../LinkBase/LinkBase.js';
import { Text } from '../Text/Text.js';
import css from './Paginator.module.css.js';

// returns the number range [page - range; page + range]
const getPageRange = (page, range) => Array.from(Array(1 + range * 2), (_, idx) => idx + page - range);
const pageClassName = clsx(css.page, 'mx-2xs flex h-lg items-center justify-center rounded border-2 border-solid px-2xs');
function Paginator({
  page,
  pageCount,
  getPageLink,
  pageRange = 2,
  shallow = false
}) {
  const pages = range(1, pageCount + 1);
  const pagesToRender = pages.filter(item => item === 1 ||
  // item is the first page
  getPageRange(page, pageRange).includes(item) ||
  // item is in the number range [page - range; page + range]
  item === pageCount);
  return jsx(Fragment, {
    children: pageCount >= 1 && jsxs("div", {
      className: "flex items-center justify-center",
      children: [jsx("div", {
        className: "mr-xs",
        children: page - 1 > 0 ? jsx(LinkBase, {
          href: getPageLink(page - 1),
          shallow: shallow,
          children: jsx(IconLeftCaret, {
            width: 12,
            height: 22,
            className: "transition duration-hover hover:text-green"
          })
        }) : jsx(IconLeftCaret, {
          width: 12,
          height: 22,
          className: "text-gray"
        })
      }), pagesToRender.map((item, idx, arr) => jsxs(React.Fragment, {
        children: [page === item ? jsx("div", {
          className: clsx(pageClassName, 'border-navy bg-navy text-white'),
          children: jsx(Text, {
            fontWeight: "semibold",
            children: item
          })
        }) : jsx(LinkBase, {
          href: getPageLink(item),
          shallow: shallow,
          children: jsx("div", {
            className: clsx(pageClassName, 'border-gray transition duration-hover hover:border-green'),
            children: jsx(Text, {
              fontWeight: "semibold",
              children: item
            })
          })
        }), item !== pageCount && arr[idx + 1] !== item + 1 && jsx("div", {
          className: css.break,
          children: "..."
        })]
      }, idx)), jsx("div", {
        className: "ml-xs",
        children: page < pageCount ? jsx(LinkBase, {
          href: getPageLink(page + 1),
          shallow: shallow,
          children: jsx(IconRightCaret, {
            width: 12,
            height: 22,
            className: "transition duration-hover hover:text-green"
          })
        }) : jsx(IconRightCaret, {
          width: 12,
          height: 22,
          className: "text-gray"
        })
      })]
    })
  });
}

export { Paginator };
